export default __webpack_public_path__ + "static/media/tenesseeMap.bb2cc67c.png";